// extracted by mini-css-extract-plugin
module.exports = {"container":"container-2AXkgep4B8ooNQPheDr5ru","flagged":"flagged-38DGPQmi5o1J1CNkUWE8Dz","icon":"icon-1vSqFDLdzf4Sdg7rPcMeya"};